import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom'
import { Provider } from 'react-redux'

import './index.scss'
import 'typeface-roboto'
import Home from './components/Home'
import App from './components/App'
import store from '../src/store/store'
import * as serviceWorker from './registerServiceWorker'
import axios from 'axios'
import { setHeader } from './common/Util'
import LanguageContextProvider from './context/LanguageContext'
import Logout from './components/Logout'
import UnAuthorize from './components/UnAuthorize'
import { fetchConfig } from './actions/configActions';


store.dispatch(fetchConfig());

// Request interceptor for API calls
axios.interceptors.request.use(request => {
    return request
})

// Response interceptor for API calls
axios.interceptors.response.use(
    response => {
        return response
    },
    async error => {
        const originalRequest = error.config
        if (error && error.response && error.response.status && error.response.status === 401) {
            return setHeader(originalRequest)
        }
        return Promise.reject(error)
    }
)

const routes = (
    <Provider store={store}>
        <Router>
            <Routes>
                <Route
                    path="/*"
                    element={
                        <LanguageContextProvider>
                            <Routes>
                                <Route path="/" element={<Home />} />
                                <Route path="/app/*" element={<App />} />
                                <Route path="/logout" element={<Logout />} />
                                <Route path="/unauthorize" element={<UnAuthorize />} />
                                <Route path="*" element={<Navigate to={`/app${window.location.search || ''}`} replace />} />
                            </Routes>
                        </LanguageContextProvider>
                    }
                />
            </Routes>
        </Router>
    </Provider>

)

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(routes)
serviceWorker.unregister()
